
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// utilities
// import cx from 'classnames';
import { filter, merge, get } from 'lodash';
import cx from 'classnames';

// components
import ProgressComponentList from '../../../../../../common/components/C_ProgressComponentList';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import Gap from './Gap';

// static constants
const formHeading = 'Employment Gap';
const formText = `
  If you had a gap in your work experience, please enter the information. If you have not been employed for a year or more prior to the date of this application, it is considered a gap.
  In addition to explaining the reason for the gap, you should include what you were doing to stay engaged, such as
  taking CE classes or other types of coursework, doing volunteer work, etc.
`;

// styling obj
const addButtonStyle = {
  display: 'inline-block',
  top: '35px',
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};


export default class EmploymentGap extends ProgressComponentList {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    employmentGaps: PropTypes.object.isRequired,
    workExperiences: PropTypes.object.isRequired,
    profileId: PropTypes.number.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context);
  }

  // Override ValidatedForm.validateForm()
  validateForm() {
    return filter(this.refs, ref => ref.validateForm)
      .reduce((valid, section, index) => section.validateForm() && valid, true);
  }

  handleRemoveGap = (clientId) =>
    () => this.removeListItem(clientId);

  render() {
    const employmentGapArr = this.getList(false, ['gapStart', 'gapEnd'], ['desc', 'desc']);

    return (
      <div className={cx('employment-gaps application-section-container clearfix')}>
        <div className='form-heading'>
          {formHeading}
        </div>
        <div className='form-text'>
          {this.props.submitted ? '' : formText}
        </div>
        {
          employmentGapArr.length > 0
          &&
          employmentGapArr.map((employmentGap, index, arr) => {
            const gap = merge({}, employmentGap, get(this.props.tempState, `employmentGaps.${employmentGap.clientId}`, {}));
            return (<Gap
              key={employmentGap.clientId}
              ref={employmentGap.clientId}
              gap={gap}
              tempState={this.props.tempState}
              onChange={this.onChange.bind(this)}
              removeListItem={this.handleRemoveGap(employmentGap.clientId)}
              validation={this.props.validation}
            />);
          }
          )
        }
        <FlatButton
          onClick={this.addListItem}
          style={{...addButtonStyle, ...(!employmentGapArr.length && {top: '10.5px'} || {})}}
          label='Add Gap'
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Experience/c_EmploymentGaps/index.js